import AppBreadcrumb from "../../components/AppBreadcrumb/AppBreadcrumb"
import MobileMenu from "../../components/MobileMenu"
import ROUTES from "../../components/Routes/routesContants"
import { useLocation, useNavigate } from "react-router-dom"
import AccountEdit from "./Participant/AccountEdit"
import ProfilePage from "./Participant/ProfilePage"
import NotificationsPage from "./NotificationsPage"
import { PreferenceOptions } from "./Utils"
import styles from "../../styles/Preferences.module.css"
import { Button } from "primereact/button"

const PreferencePage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const lastSegment = location.pathname.split("/").filter(Boolean).pop()

  const mobileMenuItems = [
    {
      id: PreferenceOptions.Account,
      label: "Account",
      icon: "pi pi-user",
      path: ROUTES.PREFERENCES_ACCOUNT,
    },
    {
      id: PreferenceOptions.Profile,
      label: "Profile",
      icon: "pi pi-user-edit",
      path: ROUTES.PREFERENCES_PROFILE,
    },
    {
      id: PreferenceOptions.Notifications,
      label: "Notifications",
      icon: "pi pi-bell",
      path: ROUTES.PREFERENCES_NOTIFICATIONS,
    },
  ]

  return (
    <div className="main-content">
      <AppBreadcrumb items={[{ label: "Preferences" }]} />
      <MobileMenu
        menuItems={mobileMenuItems}
        currentSelection={lastSegment}
      />
      <h1 className="pageTitle">Preferences</h1>
      <hr className={styles.headerLine}></hr>

      <div className="page-with-sidebar">
        <div className={styles.prefSidebar} >
          <Button
            icon="pi pi-user"
            label="Account"
            className={lastSegment === PreferenceOptions.Account ? styles.prefTabButton_selected : styles.prefTabButton}
            onClick={() => navigate(ROUTES.PREFERENCES_ACCOUNT)}
          />
          <Button
            icon="pi pi-user-edit"
            label="Profile"
            className={lastSegment === PreferenceOptions.Profile ? styles.prefTabButton_selected : styles.prefTabButton}
            onClick={() => navigate(ROUTES.PREFERENCES_PROFILE)}
          />
          <Button
            icon="pi pi-bell"
            label="Notifications"
            className={lastSegment === PreferenceOptions.Notifications ? styles.prefTabButton_selected : styles.prefTabButton}
            onClick={() => navigate(ROUTES.PREFERENCES_NOTIFICATIONS)}
          />
        </div>
        <div className={styles.wrapper}>
          {lastSegment === PreferenceOptions.Account && <AccountEdit />}
          {lastSegment === PreferenceOptions.Profile && <ProfilePage />}
          {lastSegment === PreferenceOptions.Notifications && <NotificationsPage />}
        </div>
      </div>
    </div>
  )
}

export default PreferencePage
